// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"163":"map","594":"about"}[chunkId] + "." + {"163":"d38c980c","594":"f2a1de44"}[chunkId] + ".js";
};